import {SELECT_DOCUMENT} from '../constants';

export const selectDocumentAction = (id, title, url = undefined) => ({
    type: SELECT_DOCUMENT,
    payload: {id, title, url},
});
